import { useRovoWorkspace } from '@townsquare/collab-context';

const HELLO_CLOUD_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const STAGING_TEST_CLOUD_ID = 'DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5';

export const isTabsEnabledForWorkspace = (cloudId: string | null | undefined): boolean =>
	cloudId === HELLO_CLOUD_ID || cloudId === STAGING_TEST_CLOUD_ID;

export const useIsTabsEnabled = (): boolean => isTabsEnabledForWorkspace(useRovoWorkspace());
